import {
  axiosConfig,
  del,
  get,
  patch,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  ContactFormPayload,
  ContactFormRecord,
} from "@project/types/contact-form";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/contact-form`;
const SILENT: RequestConfig = { showNotification: false };

class ContactFormService {
  listContactFormsPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<ContactFormRecord>> => {
    return fetchListPage<ContactFormRecord>(`${BASE}/`, query);
  };

  getContactForm = async (
    id: number
  ): Promise<ContactFormRecord | undefined> => {
    const data = await get<
      ApiItemResponse<ContactFormRecord> | ContactFormRecord
    >(`${BASE}/${id}/`, SILENT_LIST);
    return unwrapItem(data);
  };

  create = async (payload: ContactFormPayload): Promise<ContactFormRecord> => {
    const response = await axiosConfig.post<
      ApiItemResponse<ContactFormRecord> | ContactFormRecord
    >(`${BASE}/`, payload, SILENT);
    const item = unwrapItem(response.data);
    if (!item) {
      throw new Error("Failed to save inquiry.");
    }
    return item;
  };

  update = async (
    id: number,
    payload: Partial<ContactFormPayload>
  ): Promise<ContactFormRecord | undefined> => {
    const data = await patch<
      ApiItemResponse<ContactFormRecord> | ContactFormRecord,
      Partial<ContactFormPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const contactFormService = new ContactFormService();
